<!--<search></search>-->
<div class="row" style="margin:10px 0px;">
  <div class="col-md-12">
    <div class="panel panel-default" style="border: none;">
      <div class="panel panel-default" style="margin-top:10px;">
        <div class="panel-heading">
          <h4 class="panel-title">
            Step #1: What beaches do you want to enter data for?
          </h4>
        </div>
        <div class="panel-body text-center">
          <div class="row" style="justify-content: space-evenly;" *ngIf="!loading">

            <button class="col-md-2 btn btn-default" (click)="getBeaches('N')">North</button>

            <button class="col-md-2 btn btn-default" (click)="getBeaches('S')">South</button>
            <div class="col-md-6">
              <div class="input-group">
                <input class="form-control" [(ngModel)]="individualID"/>
                <span class="input-group-btn">
                <button class="btn btn-default" (click)="getBeaches(individualID)">Add Individual</button>
              </span>
              </div>
            </div>
          </div>
          <div class="row" style="justify-content: center;" *ngIf="loading">
            <div>
              <i class="fa fa-spinner fa-2x fa-pulse"></i>
            </div>
          </div>
          <br/>
        </div>
      </div>
      <div class="panel panel-default" style="margin-top:10px;" *ngIf="items !== undefined">
        <div class="panel-heading">
          <h4 class="panel-title">
            Step #2: Select values to apply to all activities in the list.
          </h4>
        </div>
        <div class="panel-body">
          <div class="row">
            <ng-template ngFor let-key [ngForOf]="meta.display_fields">
              <div *ngIf="key !== 'id'" class="col-lg-2 col-sm-4">
                <div [class]="{'has-error': meta.fields[key].hasError}">
                  <app-dynamic-input
                      [(item)]="item" [meta]="meta"
                      [key]="key" (itemChange)="applyChange(key, item[key])"></app-dynamic-input>
                  <label class="control-label" *ngIf="meta.fields[key].hasError">
                    {{ meta.fields[key].errorMessage }}</label>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="panel panel-default" style="margin-top:10px;" *ngIf="items !== undefined">
        <div class="panel-heading">
          <div class="panel-title">
            Step #3: Click on a monitoring activity to changes values for that specific activity.
            (Click the <i class="fa fa-times-circle-o"></i> to remove items from the list that you do
            not
            have an activity for.)
          </div>
        </div>
        <div class="panel-body">
          <div class="row" *ngIf="loading" style="padding-bottom: 10px;">
            <div class="col-md-12" style="text-align: center;">
              <i class="fa fa-pulse fa-spinner fa-2x"></i>
            </div>
          </div>
          <div class="row table-responsive" *ngIf="!loading">
            <table class="table table-striped">
              <thead>

              <tr>
                <th>
                  Beach
                </th>
                <ng-template ngFor let-key [ngForOf]="meta.display_fields">
                  <th *ngIf="meta.fields[key].type != 'field' || (meta.fields[key].type === 'field'
                                   && meta.fields[key].read_only === true)">{{ meta.fields[key].label }}
                  </th>
                </ng-template>
                <th style="width:25px">Remove</th>
              </tr>
              </thead>
              <!-- Moved ng-repeat from tbody to tr -->
              <tbody>
              <tr *ngFor="let item of items" style="border: none;">
                <td style="vertical-align: middle">
                  <span>{{ item.monitoring_location | display:meta.fields.monitoring_location.choices }}</span>
                </td>
                <ng-template ngFor let-key [ngForOf]="meta.display_fields">
                  <td *ngIf="meta.fields[key].type != 'field' || (meta.fields[key].type === 'field'
                                     && meta.fields[key].read_only === true)"
                      style="cursor: pointer; vertical-align: middle;"
                      (click)="open(item) && meta.type !== undefined">
                    <app-display-field [type]="meta.fields[key].type" [value]="item[key]"
                                       [choices]="meta.fields[key].choices"></app-display-field>
                  </td>
                </ng-template>
                <td style="vertical-align: middle; cursor: pointer;" (click)="delete(item)">
                  <i class="fa fa-times-circle-o fa-lg" style="padding:0px 30%;"></i>
                </td>
              </tr>
              </tbody>
            </table>
            <p class="text-center">
              <button class="btn btn-primary" (click)='save($event)'>Save</button>
            </p>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
